import React, { Component } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { NavLink } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { withAuth, IAuthProps } from "../../laco-common/auth/AuthContext";
import { UIStyledTooltip } from "../ui/UIComponents";
import FormWidget from "./FormWidget";

class FormPage extends Component<IAuthProps & RouteComponentProps, any> {
	render() {
		return (
			<div className="container section-padding" style={{ marginTop: "-30px" }}>
				<UIStyledTooltip title="Back to forms">
					<NavLink to="/forms">
						<IconButton edge="start" aria-label="Back to forms" className="mb-2">
							<ArrowBackIcon />
						</IconButton>
					</NavLink>
				</UIStyledTooltip>
				<FormWidget formId={(this.props.match.params as any).id} isNested={true} />
			</div>
		);
	}
}

export default withAuth(withRouter(FormPage));
